/* tslint:disable */
/* eslint-disable */
/**
 * OiOi content management API
 * OiOi content management API spec
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KeyValueProperty
 */
export interface KeyValueProperty {
    /**
     * 
     * @type {string}
     * @memberof KeyValueProperty
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof KeyValueProperty
     */
    value: string;
}

export function KeyValuePropertyFromJSON(json: any): KeyValueProperty {
    return KeyValuePropertyFromJSONTyped(json, false);
}

export function KeyValuePropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): KeyValueProperty {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': json['key'],
        'value': json['value'],
    };
}

export function KeyValuePropertyToJSON(value?: KeyValueProperty | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'value': value.value,
    };
}


